var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.warningZone)?_c('div',[_vm._v("Are you still with us?")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }